import { zzsh } from "@/axios"
import { Message } from 'element-ui'
import { bsid } from '@/common/common.js'
let that;
export default {
	data(){
		return{
			name:"小党同志",//标题
			zzname:"人民一线党支部",//党组织
			level:'优秀',
			zpLevels:["优秀","合格","基本合格","不合格"],
			levelList:[
				{
					title:"思想政治",
					level:1
				},
				{
					title:"工作汇报",
					level:3
				},
				{
					title:"工作业绩",
					level:3
				}
			],
			hpLevels:["理想信念","道德品质","组织观念","组织纪律","廉洁自律","工作业绩"],
			userList:[
				{
					title:"张小叶",
					level:1
				},
				{
					title:"王嘉尔",
					level:3
				},
				{
					title:"刘杰",
					level:3
				},
				{
					title:"张敏",
					level:3
				},
				{
					title:"吴翠翠",
					level:4
				},
			],
			dwFlies:{
				uid:this.$route.query.uid,
				year:this.$route.query.year,
				files:[]
			},
			current:1,
			totalPage:10,
			formData:{
				// 支部讲评/上级点评
				uid:this.$route.query.uid,
				year:this.$route.query.year,
				branch_content:"",//支部点评
				superior_content:""//上级点评
			},
			u_name:"",
			cy_zz:"",
			level:"",
			u_picture:""
		}
	},
	created(){that = this;},
	mounted() {that.userDetail();},
	methods:{
		// 支部/上级点评
		submit(){
			zzsh.appraiseAudit2(that.formData).then(res => {
				if(res.code == 200){
					that.userDetail()
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 党员详情
		userDetail(){
			zzsh.appraiseMemberDetail({
				uid:that.formData.uid,
				year:that.formData.year
			}).then(res => {
				if(res.code == 200){
					for(let key in res.data){
						for(let val in that.formData){
							if(key == val){
								that.formData[val] = res.data[key]
							}
						}
					}
					if(res.data.file.length>0){
						that.dwFlies.files = res.data.file;
					}else{
						that.dwFlies.files = [];
					}
					that.u_name = res.data.u_name;
					that.cy_zz = res.data.cy_zz;
					that.u_picture = res.data.u_picture;
					that.level = res.data.level_name;
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 上传限制
		limitFiles(file){
			var isJPG = file.type === 'application/pdf' 
				|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
				|| file.type === 'application/msword';
			var isLt2M = file.size / 1024 / 1024 < 20;
			if (!isJPG) {
				Message.error('仅支持pdf、doc、docx文件');
				return false;
			}
			if (!isLt2M) {
				Message.error('上传文件大小不能超过 20MB!');
				return false;
			}
		},
		// 上传成功
		success1(res, file) {
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					ment_url:res.data.src
				}
				that.dwFlies.files = [];
				that.dwFlies.files.push(data);
				that.subDwFiles();
			}else{
				Message.error("上传失败")
			}
		},
		// 上传进度
		uploadProcess(event, file, fileList){
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 上传文件
		subDwFiles(){
			zzsh.addAppraiseMemberFile(that.dwFlies).then(res => {
				if(res.code == 200){
					that.userDetail();
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 删除党员文件
		deluserFile(id){
			zzsh.delAppraisalMemberFiles({
				uid:that.formData.uid,
				id:id
			}).then(res => {
				if(res.code == 200){
					that.userDetail();
				}
			})
		}
	}
}